import { AccountProductPreferences } from "../../hooks/useAccountProductPreferences";
import { useAppForm } from "../../hooks/preferenceForm";
import { useProductPreferenceApi } from "../../hooks/useProductPreferenceApi";
import { getGeneralPreferenceDefaults } from "./generalPreferenceForm";

export const useGeneralPreferenceForm = (
  selectedPreferences: AccountProductPreferences | undefined,
  selectedUser: string
) => {
  const { create, update } = useProductPreferenceApi();

  return useAppForm({
    defaultValues: getGeneralPreferenceDefaults(selectedPreferences),
    listeners: {
      onChangeDebounceMs: 1000,
      onChange: async ({ formApi }) => {
        const { fixedShadeType } = formApi.state.values;
        if (selectedPreferences?.id) {
          await update(selectedPreferences.id, fixedShadeType);
        } else {
          await create(selectedUser, fixedShadeType);
        }
      },
    },
  });
};

export type GeneralPreferenceForm = ReturnType<typeof useGeneralPreferenceForm>;
